import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: null,
  emailList: null,
  fileName: null,
  batchName: null,
  completed: null,
  loadedBatches: []
};

const smsBatchingSlice = createSlice({
  name: "smsBatching",
  initialState,
  reducers: {
    addMessage(state, action) {
      return {
        ...state,
        message: action.payload
      };
    },
    addEmailList(state, action) {
      return {
        ...state,
        emailList: action.payload
      };
    },
    addFileName(state, action) {
      return {
        ...state,
        fileName: action.payload
      };
    },
    addBatchName(state, action) {
      return {
        ...state,
        batchName: action.payload
      };
    },
    updateCompleted(state, action) {
      return {
        ...state,
        completed: action.payload
      };
    },
    updateLoadedBatches(state, action) {
      return {
        ...state,
        loadedBatches: action.payload
      };
    },
    clearBatch() {
      return initialState;
    }
  }
});

export const {
  addMessage,
  updateStep,
  addFileName,
  addBatchName,
  updateCompleted,
  clearBatch,
  addEmailList,
  updateLoadedBatches
} = smsBatchingSlice.actions;
export default smsBatchingSlice.reducer;
